import { REQUEST_LIFE_CICLE } from 'interfaces/requests';

export const isLoading = (loadingList: REQUEST_LIFE_CICLE[]): boolean =>
  loadingList.some((loadingItem) => loadingItem === REQUEST_LIFE_CICLE.PENDING);
